import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.dokument-berechtigung-entfernen';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenDokumentBerechtigungEntfernenEffects {

    DokumentBerechtigungEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DOKUMENT_BERECHTIGUNG_ENTFERNEN),
        mergeMap((x: ac.PostDokumentBerechtigungEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDokumentBerechtigungEntfernen(x.dokumentBerechtigungRolleRequest).pipe(
                map((result: any) => {
                    return new ac.PostDokumentBerechtigungEntfernenErfolgreichAction(result, x.dokumentBerechtigungRolleRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDokumentBerechtigungEntfernenFehlerAction(error, x.dokumentBerechtigungRolleRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumentCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumentCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumentCommandService);
        }
        return this.service;
    }
}
